import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError, forkJoin, map, tap, throwError } from 'rxjs';
import { DropdownUser, UserManagement, DataUser } from 'src/services/api-services/api-interfaces/userManagement.interface';
import { APIServiceAdvisorService } from 'src/services/api-services/api-serviceadvisor-service';
import { APIUserManagamentService } from 'src/services/api-services/api-user-Management';
import { HelperService } from 'src/services/helperService';
import { PublicSiteConfig } from 'src/services/publicSiteConfig.service';
import { MatRadioChange as MatRadioChange } from '@angular/material/radio';

import { UsersComponent } from '../../users.component';
import { PublicSiteConfigBaseComponent } from 'src/app/base/publicSiteConfigBase.component';

const noSpecialCharactersValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const noSpecialChars = /^[^*+=,\/#!$%\^\*;:{}\[\]_~()@<>\?|]+$/;
  const forbidden = !noSpecialChars.test(control.value);
  return forbidden ? {'noSpecialChars': {value: control.value}} : null;
};
// ViewEncapsulation.None is takes only local sass styles
@Component({
    selector: 'app-edit-user',
    templateUrl: './edit-info-user.dialog.html',
    styleUrls: ['./edit-info-user.dialog.sass'],
    standalone: false
})
export class EditInfoUserDialog extends PublicSiteConfigBaseComponent implements OnInit {

  isLoadingSave:boolean = true;
  isUserActive:boolean = false;
  ownerRoleId: number = this.helperService.user.role.roleId
  countryId: number = this.helperService.user.countryId
  retailId: number = this.helperService.user.retailId
  userDataSelected: DataUser[] = [];
  workshopId: number = 0
  getUserData$: Observable<DataUser[]> = new Observable<DataUser[]>();
  getDropdowns$: Observable<DropdownUser[]> =  new Observable<DropdownUser[]>();
  advisorSelected$: Observable<any[]> =  new Observable<any[]>();
  graphDropdowns$: Observable<any[]> =  new Observable<any[]>();
  countrySelected$: Observable<any[]> = new Observable<any[]>();
  roleSelected$: Observable<any[]> = new Observable<any[]>();
  retailSelected$: Observable<any[]> =  new Observable<any[]>();
  workshopSelected$: Observable<any[]> =  new Observable<any[]>();

  // Function to validate the fields that are necessary
  editUserForm = this.fb.group({
    FirstName: ["",[ Validators.required, noSpecialCharactersValidator]],
    LastName: ["",[ Validators.required, noSpecialCharactersValidator]],
    Language: ["",[ Validators.required]],
    UserRole: [0,[ Validators.required]],
    IsIncadea: [0],
    Ismixto: [0],
    CompanyId: [""],
    BackendCode: [""],
    WorkshopName: [0,[ Validators.required]],
    Email: [""],
    CountryName: [0],
    AdvisorName: [0],
    RetailName: [0],
    IsActive: false
  })

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<UsersComponent>,
    public helperService: HelperService,
    @Inject(MAT_DIALOG_DATA) public user: UserManagement,
    public override publicSiteConfig: PublicSiteConfig,
    public selectWorkshop: APIServiceAdvisorService,
    public userManagmentService: APIUserManagamentService) 
  {
    super(publicSiteConfig)
  }

  protected override afterConfigLoaded(): void {
    //Get the parameters of user if the owner role is super Admin support
    if(this.ownerRoleId === 7){
      this.userManagmentService?.getUserDataById(this.user.userId).pipe(tap(response=> {this.userDataSelected = response
        this.retailId = Number(this.userDataSelected[0].RetailId)
        this.dataLoading()}
        )).subscribe({
          error: (error) => {
            // Validation 401 error
            if(error.status === 401){
              this.helperService.logoutToken()
            }
          }
        })
    }
    //Get the parameters of user if the owner role is super Retail group
    else{
      this.userManagmentService?.getUserDataById(this.user.userId).pipe(tap(response=> {this.userDataSelected = response
        this.dataLoading()}
        )).subscribe({
          error: (error) => {
            // Validation 401 error
            if(error.status === 401){
              this.helperService.logoutToken()
            }
          }
        })
    }
  }

  //Function to return the profiles according to the owner role selected
  selectRoleId(roleId: number){

    this.editUserForm.patchValue({
      WorkshopName: 0,
      AdvisorName: 0,
      RetailName: 0,
    })

    this.editUserForm.value.UserRole = roleId

    if(this.ownerRoleId === 4 ){
      this.workshopSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.editUserForm.value.CountryName), String(this.editUserForm.value.UserRole),
      this.retailId.toString())
      .pipe(map(Response=>{return Response[0]}))
    }
    else {
      this.retailSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.editUserForm.value.CountryName), String(this.editUserForm.value.UserRole))
        .pipe(map(Response=>{return Response[0]}))
    }

  }

  // Function used for super admin support profile and return country name
  selectCountry(countryId:number) {

    this.editUserForm.patchValue({
      UserRole: 0,
      WorkshopName: 0,
      AdvisorName: 0,
      RetailName: 0,
    })

    this.countryId = countryId;
    this.countrySelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.editUserForm.value.CountryName))
      .pipe(map(Response=>{return Response[0]}))

  }

  // Function used for both owner profiles and return workshops
  selectworkshop(workshopId:number){

    this.editUserForm.patchValue({
      AdvisorName: 0,
    })

    this.workshopId = workshopId
    this.advisorSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.editUserForm.value.CountryName), String(this.editUserForm.value.UserRole), this.retailId.toString(), this.workshopId.toString())
    .pipe(map(Response=>{return Response[0]}))
  }

  // Use this function for super admin support profile and return retail names
  selectRetail (retailId:number){

    this.editUserForm.patchValue({
      WorkshopName: 0,
      AdvisorName: 0,
    })

    this.retailId = retailId
    this.workshopSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId,String(this.editUserForm.value.CountryName).toString(), String(this.editUserForm.value.UserRole),
    this.retailId.toString()).pipe(map(Response=>{return Response[0]}))
  }

  // Function to return parameters for each role selected. The forkjoin is used because the response have more than one array
  selectDropdownRole(){
    switch(this.editUserForm.value.UserRole) {
      case 1:
        if (this.ownerRoleId === 7) {
          this.graphDropdowns$ = forkJoin([
            this.getDropdowns$= this.userManagmentService?.getDropdownUser(this.ownerRoleId),
            this.workshopSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId,String(this.editUserForm.value.CountryName).toString(), this.editUserForm.value.UserRole.toString(),
            this.retailId.toString())
            .pipe(map(Response=>{return Response[0]})),
            this.retailSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.editUserForm.value.CountryName).toString(), this.editUserForm.value.UserRole.toString())
            .pipe(map(Response=>{return Response[0]})),
            this.advisorSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.editUserForm.value.CountryName).toString(), this.editUserForm.value.UserRole.toString(), this.retailId.toString(), this.workshopId.toString())
            .pipe(map(Response=>{return Response[0]}))
          ]);
        }
        else {
          this.graphDropdowns$ = forkJoin([
            this.getDropdowns$= this.userManagmentService?.getDropdownUser(this.ownerRoleId,String(this.editUserForm.value.CountryName).toString(), undefined, this.retailId.toString()),
            this.workshopSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId,String(this.editUserForm.value.CountryName).toString(), this.editUserForm.value.UserRole.toString(),
            this.retailId.toString())
            .pipe(map(Response=>{return Response[0]})),
            this.advisorSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.editUserForm.value.CountryName).toString(), this.editUserForm.value.UserRole.toString(), this.retailId.toString(), this.workshopId.toString())
            .pipe(map(Response=>{return Response[0]}))
          ]);
        }
      break;

      case 2:
      case 6:
        if (this.ownerRoleId === 7) {
          this.graphDropdowns$ = forkJoin([
            this.getDropdowns$= this.userManagmentService?.getDropdownUser(this.ownerRoleId),
            this.retailSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.editUserForm.value.CountryName).toString(), this.editUserForm.value.UserRole.toString())
            .pipe(map(Response=>{return Response[0]})),
            this.workshopSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId,String(this.editUserForm.value.CountryName).toString(), this.editUserForm.value.UserRole.toString(),
            this.retailId.toString()).pipe(map(Response=>{return Response[0]})),
          ]);
        }
        else {
          this.graphDropdowns$ = forkJoin([
            this.getDropdowns$= this.userManagmentService?.getDropdownUser(this.ownerRoleId,String(this.editUserForm.value.CountryName).toString(), undefined, this.retailId.toString()),
            this.workshopSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId,String(this.editUserForm.value.CountryName).toString(), this.editUserForm.value.UserRole.toString(),
            this.retailId.toString()).pipe(map(Response=>{return Response[0]})),
          ]);
        }
      break;
      case 3:
        this.graphDropdowns$ = forkJoin([
          this.getDropdowns$= this.userManagmentService?.getDropdownUser(this.ownerRoleId).pipe(map((response)=> {
            let roles:any[] =[]
              if(this.userDataSelected[0].IsIncadea === 1){
                  response[1].forEach((user)=>{
                    if(user.RoleId === 3||  user.RoleId === 4)
                      {
                        roles[roles.length]= user;
                      }
                  }
                  )
                  response[1] = roles
              }
            return response
          }))
        ]);
      break;
      case 4:
        if(this.userDataSelected[0].IsIncadea === 1){
          this.graphDropdowns$ = forkJoin([
            this.getDropdowns$= this.userManagmentService?.getDropdownUser(this.ownerRoleId).pipe(map((response)=> {
              let roles:any[] =[]
                if(this.userDataSelected[0].IsIncadea === 1){

                    response[1].forEach((user)=>{
                      if(user.RoleId === 3||  user.RoleId === 4)
                        {
                          roles[roles.length]= user;
                        }
                    }
                    )
                    response[1] = roles
                }

              return response
            }))
          ]);

        }
        else{
          this.graphDropdowns$ = forkJoin([
            this.getDropdowns$= this.userManagmentService?.getDropdownUser(this.ownerRoleId).pipe(map((response)=> {
              let roles:any[] =[]
                if(this.userDataSelected[0].IsIncadea === 1){

                    response[1].forEach((user)=>{
                      if(user.RoleId === 3||  user.RoleId === 4)
                        {
                          roles[roles.length]= user;
                        }
                    }
                    )
                    response[1] = roles
                }

              return response
            })),
            this.workshopSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId,String(this.editUserForm.value.CountryName).toString(), this.editUserForm.value.UserRole.toString(),
            this.retailId.toString()).pipe(map(Response=>{return Response[0]})),
            this.retailSelected$ = this.userManagmentService?.getDropdownUser(this.ownerRoleId, String(this.editUserForm.value.CountryName).toString(), this.editUserForm.value.UserRole.toString())
            .pipe(map(Response=>{return Response[0]}))
          ]);
        }

    }
  }

  // Function to save the updated user and show toasts
  onSaveEditUser(){
    let retailIdLocation:any= null
    if(this.editUserForm.value.UserRole === 4){ retailIdLocation = this.retailId.toString() }
    this.isLoadingSave = false
    let isActiveString = "0"
    if(this.editUserForm.value.IsActive === true){
      isActiveString = "1"
      }
      //It is sent in this format because the values are being brought from the form
      this.userManagmentService?.createUser(String(this.editUserForm.value.FirstName),
      String(this.editUserForm.value.LastName),String(this.editUserForm.value.Email),
      String(this.editUserForm.value.CountryName).toString(),
      String(this.editUserForm.value.Language),
      String(this.editUserForm.value.UserRole),isActiveString,
      String(this.editUserForm.value.IsIncadea),
      String(this.editUserForm.value.Ismixto),
      String(this.editUserForm.value.CompanyId),
      retailIdLocation,
      String(this.editUserForm.value.WorkshopName),
        String(this.editUserForm.value.AdvisorName))
      .subscribe({
        next:(response)=>{
          this.dialogRef.close();
          if(response.Result === "User Created Successfully"){
            const translateTextSuccess = this.translate.instant("ToastUpdateUser",{User:String(this.editUserForm.value.FirstName)+ ' ' + String(this.editUserForm.value.LastName)});
            this.helperService.showAlert =true
            this.helperService.typeAlert ="success"
            this.helperService.messageAlert =translateTextSuccess
            setTimeout(() => {
              this.helperService.showAlert =false

              }, 7000)
          }
            this.isLoadingSave = true
        },   error: (failed) => {
              // Validation 401 error
              if (failed.status === 401) {
                this.helperService.logoutToken();
              }

              this.dialogRef.close();
              if (failed.error.status === 400) {
                const translateTextError = this.translate.instant("ToastErrorUpdateUser");
                this.helperService.showAlert =true
                this.helperService.typeAlert ="error"
                this.helperService.messageAlert =translateTextError
                setTimeout(() => {
                  this.helperService.showAlert =false

                  }, 7000)
              }
            }
      })
  }

  // Function to pre-loading data in each field of the dialog
  dataLoading(){
    this.editUserForm.patchValue({
      FirstName: String(this.userDataSelected[0].FirstName),
      LastName: String(this.userDataSelected[0].LastName),
      UserRole: Number(this.userDataSelected[0].RoleId),
      WorkshopName: Number(this.userDataSelected[0].WorkshopId),
      Language: String(this.userDataSelected[0].Language),
      CountryName: Number(this.userDataSelected[0].CountryId),
      AdvisorName: Number(this.userDataSelected[0].AdvisorId),
      RetailName: Number(this.userDataSelected[0].RetailId),
      Email: String(this.userDataSelected[0].Email),
      IsActive: Boolean(this.userDataSelected[0].IsActive),
      IsIncadea: Number(this.userDataSelected[0].IsIncadea),
      CompanyId: String(this.userDataSelected[0].CompanyId),
      BackendCode: String(this.userDataSelected[0].BackendCode),
      Ismixto:Number(this.userDataSelected[0].UserMix)
    })

    this.editUserForm.value.UserRole = Number(this.userDataSelected[0].RoleId)
    this.workshopId = Number(this.userDataSelected[0].WorkshopId)
    this.selectDropdownRole()
  }

  // Update roles dropdown incadea
  onRadioChange(event: MatRadioChange) {
    if (this.ownerRoleId === 7) {
      this.graphDropdowns$ = forkJoin([
        this.getDropdowns$= this.userManagmentService?.getDropdownUser(this.ownerRoleId).pipe(
          map((response)=>{
            let roles:any[] = []
            if(this.editUserForm.value.IsIncadea === 1){
              response[1].forEach(role => {
                if(role.RoleId === 3 || role.RoleId === 4 ){
                  roles[roles.length] = role
                }
              });
              response[1] = roles
            }
            return response
          }),
          catchError((error) => {
            // Manejo de error 401
            if (error.status === 401) {
              this.helperService.logoutToken();
            }

            return throwError(() => error);
          }))
      ]);
    }
  }

  onRadioChangeMixto(event: MatRadioChange) {

    if(this.editUserForm.value.Ismixto === 1){
    this.editUserForm.patchValue({
      IsIncadea : 0
    });

    }
  }

  //Function to validate that the required fields are completed
  formsValidations(): boolean {
    const isFormValidationInvalid = this.editUserForm!.invalid
    return isFormValidationInvalid;
  }
}
